/**
 * Weitzman collection: MoMA-inspired sidebar layout (.wtz-bk-layout).
 * Mobile nav drawer, category nav -> panel swapping (with hash sync and
 * collapsed-group auto-open), and each panel's own client-side sort.
 * Extracted verbatim from sections/weitzman-collection.liquid.
 */
(function () {
  const bkRoot = document.querySelector('.wtz-bk-layout');
  if (!bkRoot) return;

  // Drawer elements + close/open are defined and wired FIRST, before the
  // initial activate() call below (which calls closeDrawer() on every
  // run): the ground-truth prototype (previews/collection-books-v2.html)
  // shipped this same drawer with the assignments coming AFTER that
  // first activate() call, so closeDrawer() threw on page load, the
  // exception aborted the whole IIFE, and the drawer's open/close
  // listeners never attached on any device. Caught in QA before this
  // port; keeping the fix note here so this order doesn't drift back.
  const toggle = bkRoot.querySelector('[data-bk-nav-open]');
  const drawerPanel = bkRoot.querySelector('[data-bk-nav-panel]');
  const overlay = bkRoot.querySelector('[data-bk-nav-overlay]');
  const closeBtn = bkRoot.querySelector('[data-bk-nav-close]');
  /* Where focus was before the drawer opened, so it can be put back rather
     than dumping the user at the top of the document. */
  let lastFocus = null;
  function openDrawer() {
    if (!drawerPanel || !overlay) return;
    lastFocus = document.activeElement;
    drawerPanel.classList.add('is-open');
    overlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (closeBtn) closeBtn.focus();
  }
  function closeDrawer() {
    if (!drawerPanel || !overlay) return;
    drawerPanel.classList.remove('is-open');
    overlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    lastFocus = null;
  }
  if (toggle) toggle.addEventListener('click', openDrawer);
  if (overlay) overlay.addEventListener('click', closeDrawer);
  if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
  document.addEventListener('keydown', function (e) {
    /* Was firing closeDrawer() on every keydown regardless of whether the
       drawer was open, which also meant focus was being restored to a stale
       element on unrelated keystrokes. */
    if (!drawerPanel || !drawerPanel.classList.contains('is-open')) return;
    if (e.key === 'Escape') { closeDrawer(); return; }
    if (e.key === 'Tab' && window.WTZ && window.WTZ.trapFocus) {
      window.WTZ.trapFocus(drawerPanel, e);
    }
  });

  // Nav wiring: click a sidebar/drawer item -> swap the active panel.
  const links = bkRoot.querySelectorAll('[data-bk-nav-link]');
  const panels = bkRoot.querySelectorAll('[data-bk-panel]');
  const navItems = bkRoot.querySelectorAll('.wtz-bk-nav__item');
  const currentLabel = bkRoot.querySelector('[data-bk-current-label]');
  const content = bkRoot.querySelector('.wtz-bk-content');

  function activate(target, opts) {
    opts = opts || {};
    panels.forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-bk-panel') === target); });
    navItems.forEach(function (li) {
      const link = li.querySelector('[data-target]');
      li.classList.toggle('is-active', link && link.getAttribute('data-target') === target);
    });
    const activeLink = bkRoot.querySelector('[data-bk-nav-list] [data-target="' + target + '"]');
    if (activeLink && currentLabel) currentLabel.textContent = activeLink.textContent.trim();
    // If the active link sits inside a collapsed sidebar group (e.g.
    // Ketubah's Artist/Price/Style/Text accordions), open that group so
    // the highlighted item is actually visible instead of hidden behind
    // a closed <details>.
    if (activeLink) {
      const ownerGroup = activeLink.closest('.wtz-bk-nav__group-details');
      if (ownerGroup) ownerGroup.open = true;
    }
    if (!opts.skipHash) history.replaceState(null, '', '#' + target);
    if (opts.scrollTop && content) content.scrollIntoView({ behavior: 'smooth', block: 'start' });
    closeDrawer();
  }

  links.forEach(function (link) {
    link.addEventListener('click', function (e) {
      e.preventDefault();
      activate(link.getAttribute('data-target'), { scrollTop: window.innerWidth <= 900 });
    });
  });

  let initial = (window.location.hash || '#all').slice(1);
  if (!bkRoot.querySelector('[data-bk-panel="' + initial + '"]')) initial = 'all';
  activate(initial, { skipHash: true });

  // Per-panel client-side sort: reorders that one panel's own cards
  // only. collection.sort_options belongs to this page's primary
  // `collection`, not to the other collections each category points
  // at, so there is no server-side sort to request without navigating
  // away from the panel.
  bkRoot.querySelectorAll('[data-bk-sort]').forEach(function (select) {
    select.addEventListener('change', function () {
      const panel = select.closest('.wtz-bk-panel');
      const grid = panel ? panel.querySelector('[data-bk-grid]') : null;
      if (!grid) return;
      const mode = select.value;
      if (!mode) return;
      const cards = Array.prototype.slice.call(grid.querySelectorAll('.wtz-bk-card-wrap'));
      cards.sort(function (a, b) {
        if (mode === 'price-asc') return (parseFloat(a.dataset.price) || 0) - (parseFloat(b.dataset.price) || 0);
        if (mode === 'price-desc') return (parseFloat(b.dataset.price) || 0) - (parseFloat(a.dataset.price) || 0);
        if (mode === 'name-asc') return (a.dataset.name || '').localeCompare(b.dataset.name || '');
        return 0;
      });
      cards.forEach(function (card) { grid.appendChild(card); });
    });
  });
})();
